import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

const StatusBadge = ({ textColor, bgColor, dotColor, label }) => {
  return (
    <p
      className={clsx(
        'flex w-max items-center gap-1.5 rounded-[50px] px-3 py-0.5 text-[11px] font-semibold',
        bgColor,
        textColor
      )}
    >
      <span
        className={clsx('block h-1.5 w-1.5 rounded-full bg-current', dotColor)}
      />
      <span>{label}</span>
    </p>
  );
};

export default function UserStatus({ status }) {
  const action =
    status && Object.prototype.hasOwnProperty.call(status, 'key')
      ? status?.key?.toLowerCase()
      : status;
  const label = status?.label || null;

  const { t } = useTranslation('forms');

  if (!action) {
    return 'N/A';
  }

  return (
    <StatusBadge
      textColor={status.textColor}
      bgColor={status.bgColor}
      dotColor={status.textColor}
      label={label ?? t(action)}
    />
  );
}
